import React from 'react';
import { Link } from 'react-router-dom';
import UserProfile from './UserProfile';

const Header = () => {
  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* YK Logo - Left Corner */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://stssevastorage.blob.core.windows.net/ykwebsite/logo.png" 
              alt="Yugal Kunj" 
              className="h-14 w-auto"
            />
          </Link>

          {/* Login Button - Right Corner */}
          <div className="flex items-center">
            <UserProfile />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
